import { Input } from '@/components/ui/input';

export const PeriodFields = ({ period, onChange, prefix }) => (
  <div className="flex flex-wrap items-end gap-3" data-testid={`${prefix}-period`}>
    <label className="text-sm min-w-0">Du
      <Input type="date" value={period.start} onChange={e => onChange({ ...period, start: e.target.value })} data-testid={`${prefix}-start-date`} />
    </label>
    <label className="text-sm min-w-0">Au
      <Input type="date" value={period.end} onChange={e => onChange({ ...period, end: e.target.value })} data-testid={`${prefix}-end-date`} />
    </label>
  </div>
);